import { Col, Row, Image } from 'antd';
import HeaderMenu from './HeaderMenu';
import Img from '../../assets/anytime.png';

export default function MainHeader({ headerMenuRender }) {
  return (
    <Row>
      <Col xs={2} sm={2} md={2} lg={2}>
        <Image src={Img} alt="anytimeLogo" width={150} preview={false} />
      </Col>
      {headerMenuRender && (
        <Col
          xs={{ span: 6,offset:12}}
          sm={{ span: 6,offset:12 }}
          md={{ span: 18, offset: 2 }}
        >
          <HeaderMenu />
        </Col>
      )}
    </Row>
  );
}
